<template>
    <b-col>
      <div class="d-flex d-flex justify-content-end">
        <b-form-select class="select-year" v-model="selectedYear">
          <b-form-select-option v-for="year in years" :key="year" :value="year">{{year}}</b-form-select-option>
        </b-form-select>
      </div>
    <div class="row mt-2">
    <div class="col-sm-6 col-lg-3">
        <div class="card border border-secondary">
          <div class="card-body">
            <div class="h4 text-right text-muted"><i class="fa fa-calendar-o text-info"></i></div>
            <div class="h3 m-0 mb-2">{{statistic.processed ? statistic.processed : 0}}</div>
            <p class="text-muted">{{$t('CURRENT_YEAR')}}</p>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3">
        <div class="card border border-secondary">
          <div class="card-body">
            <div class="h4 text-right text-muted"><i class="fa fa-check-circle-o text-primary"></i></div>
            <div class="h3 m-0 mb-2">{{statistic.recognized ? statistic.recognized  : 0}}</div>
            <p class="text-muted">{{$t('RECOGNIZED_QUALIFICATION')}}</p>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3">
        <div class="card border border-secondary">
          <div class="card-body">
            <div class="h4 text-right text-muted"><i class="fa fa-close text-danger"></i></div>
            <div class="h3 m-0 mb-2">{{statistic.not_recognized ? statistic.not_recognized :0}}</div>
            <p class="text-muted">{{$t('NOT_RECOGNIZED_QUALIFICATION')}}</p>
          </div>
        </div>
      </div>

      <div class="col-sm-6 col-lg-3">
        <div class="card border border-secondary">
          <div class="card-body">
            <div class="h4 text-right text-muted"><i class="fa fa-minus-square-o text-warning"></i></div>
            <div class="h3 m-0 mb-2">{{statistic.in_process ? statistic.in_process : 0}}</div>
            <p class="text-muted">{{$t('STATISTIC_UNRECOGNIZED')}}</p>
          </div>
        </div>
      </div>
    </div>
    </b-col>
</template>

<script>
  import moment from "moment";
  import {statisticApplicant} from '@/services/applicant/index'
  const currentYear = new Date().getFullYear();
  const startYear = 2022;
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  );

  export default {
    name: "StatisticNumber",
    props:{
      institution:{
        type:Object,
        default(){
          return {
            id:null
          }
        }
      }
    },
    data() {
      return {
        years,
        statistic: {},
        moment,
        selectedYear: moment().format('YYYY')
      }
    },
    computed:{
      userRole(){
        return this.$store.getters['user/getUserRole']
      },
    },
    methods: {
     async fetchData(year) {
       let post = {
         institution:this.institution.id,
         year
       }
       if(this.institution && this.institution.id){
         post.institution =this.institution.id;
       }
       console.log(post,3)
       await statisticApplicant(post).then(response => {
         this.statistic = response.data
       })
      },
    },
    watch: {
      selectedYear: {
        handler(value) {
          this.fetchData(Number(value))
        },
        immediate: true
      }
    },
  }
</script>

<style scoped>
  .card-body {
    height: 140px;
  }
  .select-year{
    max-width: 5rem;
  }
</style>
